module.exports = __webpack_public_path__ + "media/images/news/icon_bottom-7a267b65325ac8c5a9e80aa8e4360a8b.svg";